import { cn } from '@global/utils/styling';
import './style.scss';
import { COMMON_INPUT_ICON_TEST_ID, COMMON_INPUT_TEST_ID } from './consts';
import { DisabledInputFunctions } from '@global/utils/disabledInputFunctions';

export interface CommonInputProps {
  value?: string;
  type?: string;
  className?: string;
  placeholder?: string;
  label?: string;
  icon?: React.ReactNode;
  onIconClick?: () => void;
  onChange?: () => void;
  onBlur?: () => void;
  error?: boolean;
  isValid?: boolean;
  errorMessage?: string;
  children?: React.ReactNode;
  labelIcon?: React.ReactNode;
  id?: string;
  disabled?: boolean;
  defaultValue?: string;

  disabledInputFunctions?: DisabledInputFunctions;
  'data-testid'?: string;
}

export const CommonInput = (props: CommonInputProps) => {
  return (
    <>
      <div className={cn('common-input', [props.className || ''])}>
        {props.label && (
          <label
            className="common-input__label text-subtitle-2"
            htmlFor={props.id}
          >
            {props.label}
            {props.labelIcon}
          </label>
        )}
        <input
          data-testid={props['data-testid'] || COMMON_INPUT_TEST_ID}
          id={props.id}
          className={cn({
            error: props.error,
            valid: props.isValid,
          })}
          disabled={props.disabled}
          placeholder={props.placeholder}
          value={props.value}
          onChange={props.onChange}
          onBlur={props.onBlur}
          type={props.type || 'text'}
          {...props.disabledInputFunctions}
        />
        {props.icon && (
          <button
            data-testid={COMMON_INPUT_ICON_TEST_ID}
            className="common-input__icon"
            type="button"
            onClick={props.onIconClick}
          >
            {props.icon}
          </button>
        )}
        {props.children && (
          <div className="common-input__children">{props.children}</div>
        )}
        {props.error && props.errorMessage && (
          <p className="common-input__error-message">{props.errorMessage}</p>
        )}
      </div>
    </>
  );
};

CommonInput.defaultProps = {
  type: 'text',
};
